import CallCenterForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCenterForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('programationReport.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.programationReport.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true
        console.log(this.data)

        this.$setBreadcrumbs([
          // eslint-disable-next-line max-len
          {label: this.$t('breadcrumbs.programationReport.index'), route: {name: 'programation-report-index'}},
          {label: this.$t('breadcrumbs.programationReport.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallCenter(data) {
      API.programationReport.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('programationReport.edit.succesfullyUpdated'))
        this.$router.push({name: 'programation-report-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
